<script lang="ts">
  import Loading from '$lib/components/Loading.svelte';
  import UserDetails from '$lib/components/users/UserDetails.svelte';
  import type { PageProps } from './$types';

  const { data }: PageProps = $props();
</script>

{#await data.userPromise}
  <Loading />
{:then user}
  <UserDetails {user} classesPromise={data.classesPromise} route="instructor" />
{/await}
